export const SCOPE = {
  NEED_ACTION : 'need_action',
  SENT        : 'sent',
  ALL         : 'all',
}

export const CATEGORIES = {
  OFFLINE : 'offline',
  ONLINE  : 'online'
}

export const PAYMENT_STATE = {
  PENDING     : 'pending',
  CAPTURE     : 'capture',
  SETTLEMENT  : 'settlement',
}

export const PER_PAGE_OPTIONS = [
  {
    'label' : '10',
    'value' : '10'
  },
  {
    'label' : '25',
    'value' : '25'
  },
  {
    'label' : '50',
    'value' : '50'
  },
  {
    'label' : '100',
    'value' : '100'
  }
]

export const SORT_OPTIONS = [
  {
    'id'       : 1,
    'label'    : 'Terakhir',
    'sort_by'  : 'payments.created_at',
    'sort_dir' : 'desc'
  },
  {
    'id'       : 2,
    'label'    : 'Terawal',
    'sort_by'  : 'payments.created_at',
    'sort_dir' : 'asc'
  }
]
